import {ValueObject} from '@s-ui/domain'

export class SeoMakeMetaInformationMapper extends ValueObject {
  constructor({seoDataValueObjectFactory, seoDataMapper, seoLiteralMapper, config}) {
    super()
    this._seoDataMapper = seoDataMapper
    this._seoLiteralMapper = seoLiteralMapper
    this._config = config
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
  }

  /**
   * @method
   */
  async map({culture, pageName, params = {}}) {
    const {make, makeSlug} = params
    const protocol = this._config.get('URL_PROTOCOL')
    const host = this._config.get('HOST_DOMAIN')
    const siteUrl = `${protocol}${host}`
    const makePageSeo = this._config.get('seo').makePageSeo

    const {H1, TITLE, META_DESCRIPTION, CANONICAL, META_ROBOTS} = makePageSeo[culture]

    const placeholderValues = {
      make,
      makeSlug,
      siteUrl
    }

    const parsedH1 = this._seoLiteralMapper.setText({text: H1}).setPlaceholderValues({placeholderValues}).map()

    const parsedCanonical = this._seoLiteralMapper
      .setText({text: CANONICAL})
      .setPlaceholderValues({placeholderValues})
      .map()

    const parsedTitle = this._seoLiteralMapper.setText({text: TITLE}).setPlaceholderValues({placeholderValues}).map()

    const parsedDescription = this._seoLiteralMapper.setText({text: META_DESCRIPTION}).map()

    const {
      links,
      metas,
      scripts,
      title: seoTitle
    } = this._seoDataMapper
      .title(parsedTitle)
      .description(parsedDescription)
      .canonical(parsedCanonical)
      .robots(META_ROBOTS)
      .map()

    return this._seoDataValueObjectFactory({
      h1: parsedH1,
      head: {
        link: links,
        meta: metas,
        scripts,
        title: seoTitle
      }
    })
  }
}
